import type { EnrichmentStatus } from '@/features/catalog/types';

const STYLES: Record<EnrichmentStatus, { ring: string; dot: string }> = {
  pending:  { ring: 'bg-accent-amber/10 text-accent-amber ring-accent-amber/30',         dot: 'bg-accent-amber' },
  approved: { ring: 'bg-accent-sky/10 text-accent-sky ring-accent-sky/30',               dot: 'bg-accent-sky' },
  applied:  { ring: 'bg-brand-50 dark:bg-brand-900/30 text-brand-700 ring-brand-200',                          dot: 'bg-brand-500' },
  rejected: { ring: 'bg-ink-100 dark:bg-white/[0.06] text-ink-500 dark:text-ink-400 ring-ink-200',                              dot: 'bg-ink-400' },
  failed:   { ring: 'bg-accent-crimson/10 text-accent-crimson ring-accent-crimson/30',   dot: 'bg-accent-crimson' },
};

export function EnrichmentStatusPill({ status }: { status: EnrichmentStatus }): JSX.Element {
  const s = STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 font-mono text-[10px] font-semibold tracking-[0.08em] ring-1 ring-inset ${s.ring}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status.toUpperCase()}
    </span>
  );
}
